import 'emoji-mart/css/emoji-mart.css';
import 'preact/debug';
import './styles/index.scss';

export { default } from './components/App';
